import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from 'components/InputField';
import SelectField from 'components/SelectField';
import FormError from 'components/FormError';

const EditCrontabForm = ({
  handleSubmit,
  timezoneOptions,
  error,
  handleDelete,
  closeModal,
}) => {
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="crontab-fields">
          <Field component={InputField} name="minute" label="Minute" />
          <Field component={InputField} name="hour" label="Hour" />
          <Field
            component={InputField}
            name="day_of_week"
            label="Day of week"
          />
          <Field
            component={InputField}
            name="day_of_month"
            label="Day of month"
          />
          <Field
            component={InputField}
            name="month_of_year"
            label="Month of year"
          />
          <Field
            component={SelectField}
            options={timezoneOptions}
            name="timezone"
            label="Timezone"
            empty="Select timezone"
          />
        </div>
        {error && <FormError error={error} />}
        <br />
        <div className="d-flex">
          <button className="btn btn-primary mar-r" type="submit">
            Save
          </button>
          <button
            className="btn btn-danger mar-r"
            type="button"
            onClick={handleDelete}
          >
            Delete
          </button>
          <button
            className="btn btn-default"
            type="button"
            onClick={closeModal}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};
const validate = (values) => {
  let errors = {};

  const requiredFields = [
    'minute',
    'hour',
    'day_of_week',
    'day_of_month',
    'month_of_year',
  ];

  requiredFields.forEach((key) => {
    if (!values[key]) {
      errors[key] = 'Required';
    }
  });

  return errors;
};

export default reduxForm({
  form: 'editCrontabForm',
  validate,
  enableReinitialize: true,
})(EditCrontabForm);
